export default __webpack_public_path__ + "static/media/news-left-big-homepage.3041d336.png";